<script setup lang="ts">

import UserCard from "@/components/cards/UserCard.vue";
import {Project, User} from "@/types";
import {ref, watch} from "vue";
import {route} from "ziggy-js";
import {router, usePage} from "@inertiajs/vue3";
import TextField from "@/components/forms/TextField.vue";

interface Props {
  user: User
  projects: Array<Project>
}

const props = defineProps<Props>()

const page = usePage()
const search = ref('')

watch(search, (value) => {
    router.visit(route('dashboard', {
        _query: {
            search: value,
        }
    }), {
        preserveState: true,
    })
})
</script>

<template>
    <user-card
        class="mt-5"
        :user="props.user"
    />
    <v-list>
        <v-list-item
            density="compact"
            :slim="true"
        >
            <template #title>
                <span class="font-weight-bold text-body-2 text-grey-darken-4">
                    Your Projects
                </span>
            </template>
            <template #append>
                <success-btn
                    position="relative"
                    size="small"
                    prepend-icon="mdi-folder-outline"
                    rounded="lg"
                    @click="$inertia.visit(route('projects.create'))"
                >
                    New
                </success-btn>
            </template>
        </v-list-item>
        <text-field
            v-model="search"
            placeholder="Find a project..."
            field-class="mx-3 mb-2"
            :hide-details="true"
        />
        <v-list-item
            v-for="project in projects"
            :key="project.slug"
            density="compact"
            :slim="true"
            rounded="lg"
            @click="router.visit(route('projects.show', {project: project.slug}))"
        >
            <template #title>
                <span class="text-body-2 text-underlined__hover">
                    {{ project.name }}
                </span>
            </template>
        </v-list-item>
    </v-list>
</template>

<style scoped>
.text-underlined__hover:hover {
    text-decoration: underline;
}
</style>
